import React, { useState, useEffect, useCallback } from 'react';
import SearchBar from './SearchBar';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { get, set } from 'global/lib/lodash';
import setFilter from 'redux/actions/setFilter';
import useDebounce from 'global/hooks/useDebounce';

const withSearchBar = (ListComponent) => {
  return (props) => {
    const dispatch = useDispatch();
    const store = useStore();
    const split = get(props, '_location.pathname', get(props, 'location.pathname', ''))
      .split('/')
      .filter((s) => s);
    const filter = useSelector((state) => get(state, ['filter', ...split]));

    const [searchString, changeSearchString] = useState(get(filter, 'searchstring', ''));

    const applySearch = useCallback(
      (nextSearch = searchString) => {
        if (filter && split.length >= 2) {
          const sState = store.getState();
          const filt = get(sState, ['filter', ...split]);
          dispatch(setFilter(split[0], split[1], set({ ...filt }, 'searchstring', nextSearch)));
        }

        if (props.onSearchChange) {
          props.onSearchChange(nextSearch);
        }
      },
      [dispatch, filter, props.onSearchChange, searchString, split, store]
    );

    useDebounce(searchString, 500, () => {
      applySearch(searchString);
    });

    const clearSearch = () => {
      changeSearchString('');
    };

    useEffect(() => {
      changeSearchString(get(filter, 'searchstring', ''));
    }, [filter]);

    const {
      belowSearchBar,
      sort,
      hideSortWhenSearching,
      loading,
      onAiSearch,
      aiLoading,
      SearchIcon,
      sidebar,
      disableInputPaddingLeft,
      containerStyle,
    } = props;
    const hideSort = hideSortWhenSearching && !!(searchString || '').trim();

    return (
      <>
        <SearchBar
          sort={hideSort ? undefined : sort}
          loading={loading}
          onAiSearch={onAiSearch}
          aiLoading={aiLoading}
          SearchIcon={SearchIcon}
          sidebar={sidebar}
          disableInputPaddingLeft={disableInputPaddingLeft}
          containerStyle={containerStyle}
          onClear={() => clearSearch()}
          changeSearch={changeSearchString}
          searchString={searchString}
        />
        {belowSearchBar}
        <ListComponent searchString={searchString} {...props} />
      </>
    );
  };
};

export default withSearchBar;
